"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRangeslider = _interopRequireDefault(require("react-rangeslider"));
require("react-rangeslider/lib/index.css");
var _reactNumericInput = _interopRequireDefault(require("react-numeric-input"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Typeahead = _interopRequireDefault(require("./Typeahead/Typeahead.js"));
var _Uploader = _interopRequireDefault(require("./Uploader/Uploader.js"));
require("./HoldingsEditor.css");
var _i18n = _interopRequireDefault(require("../../../util/i18n.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const HoldingsEditor = _ref => {
  let {
    initialHoldings = null,
    checkTickersUrl = 'https://dpd.wisdomtree.com',
    updateHoldings = null,
    totalValue = 1000000,
    typeHeadPlaceholder,
    token,
    dataspanApiUrl = 'https://dataspanapi.wisdomtree.com',
    clientEmail,
    updateSumWeightsCallback
  } = _ref;
  const [holdings, setHoldings] = (0, _react.useState)(() => {
    if (initialHoldings) {
      return initialHoldings.tickers.map((ticker, index) => ({
        ticker,
        weight: initialHoldings.weights[index],
        name: initialHoldings.names[index],
        externalID: initialHoldings.externalIDs[index],
        amount: initialHoldings.weights[index] * totalValue
      }));
    } else {
      return null;
    }
  });
  const [sumWeights, setSumWeights] = (0, _react.useState)(null);
  const [totalValueState, setTotalValueState] = (0, _react.useState)(totalValue);
  const [weightType, setWeightType] = (0, _react.useState)('percent');
  const [failuredFunds, setFailuredFunds] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    sumWeightsFn(holdings);
  }, [holdings]);
  const handleEntitySelection = entity => {
    let newHolding = {
      ticker: entity.ticker,
      weight: 0,
      amount: 0,
      name: entity.name,
      externalID: entity.externalID
    };
    let newHoldings = holdings ? holdings.concat(newHolding) : [newHolding];
    newHoldings = rebalanceWeights(newHoldings);
    setHoldings(newHoldings);
    if (updateHoldings) {
      updateHoldings(newHoldings);
    }
    sumWeightsFn(newHoldings);
  };
  const handleDeleteHolding = entity => {
    const newHoldings = holdings.filter(holding => holding.externalID !== entity.externalID);
    setHoldings(newHoldings.length > 0 ? newHoldings : null);
    if (updateHoldings) {
      updateHoldings(newHoldings);
    }
    sumWeightsFn(newHoldings);
  };
  const handleDeleteAllHoldings = () => {
    setHoldings(null);
    if (updateHoldings) {
      updateHoldings(null);
    }
  };
  const handleUploadHoldings = (uploadedHoldings, failures) => {
    const newHoldings = rebalanceWeightsAndAmounts(uploadedHoldings);
    setHoldings(newHoldings);
    setFailuredFunds(failures);
    if (updateHoldings) {
      updateHoldings(newHoldings);
    }
  };
  const handleChangeWeightingType = weightType => {
    setWeightType(weightType);
  };
  const handleUpdateSlider = (value, holding) => {
    value = weightType === 'percent' && value > 1 ? 1 : value;
    let newHoldings = holdings.map(originalHolding => {
      if (originalHolding.externalID === holding.externalID) {
        if (weightType === 'currency') {
          originalHolding.weight = value / totalValueState;
          originalHolding.amount = value;
        } else {
          originalHolding.weight = value;
          originalHolding.amount = value * totalValueState;
        }
      }
      return originalHolding;
    });
    if (newHoldings.length === 1) {
      newHoldings[0].weight = 1;
      if (weightType === 'percent') {
        newHoldings[0].amount = totalValueState;
      }
    }
    newHoldings = rebalanceWeightsAndAmounts(newHoldings);
    setHoldings(newHoldings);
    if (updateHoldings) {
      updateHoldings(newHoldings);
    }
  };
  const sumWeightsFn = holdings => {
    if (holdings) {
      let sumWeights = sumArrayField(holdings, 'weight');
      let totalValue = sumArrayField(holdings, 'amount');
      setSumWeights(sumWeights);
      setTotalValueState(totalValue);
      if (updateSumWeightsCallback) {
        updateSumWeightsCallback(sumWeights);
      }
    }
  };
  const sumArrayField = (array, fieldName) => {
    try {
      let fieldArray = array.map(elem => elem[fieldName]);
      return fieldArray.reduce((sum, num) => sum + num);
    } catch (err) {
      return 0;
    }
  };
  const rebalanceWeightsAndAmounts = holdings => {
    let totalValue = sumArrayField(holdings, 'amount');
    let sumWeights = sumArrayField(holdings, 'weight');
    setSumWeights(sumWeights);
    setTotalValueState(totalValue);
    if (holdings.length > 1) {
      if (weightType === 'currency') {
        holdings.forEach(holding => {
          holding.weight = holding.amount / totalValue;
        });
      } else {
        holdings.forEach(holding => {
          holding.amount = holding.weight / sumWeights * totalValue;
        });
      }
    }
    return holdings;
  };
  const rebalanceWeights = holdings => {
    let count = holdings.length;
    if (count === 1) {
      holdings[0].weight = 1;
      holdings[0].amount = 1000000;
      return holdings;
    }
    let weights = holdings.map(holding => holding.weight);
    let originalWeights = [...weights].slice(0, -1);
    let isProportional = originalWeights.every((val, i, arr) => val === arr[0]);
    if (isProportional) {
      weights[weights.length - 1] = weights[0];
    } else {
      let proportionalPercentage = 1.0 / count;
      weights[weights.length - 1] = proportionalPercentage;
    }
    let sumWeights = weights.reduce((sum, num) => sum + num);
    let newWeights = weights.map(weight => weight / sumWeights);
    holdings.forEach((holding, index) => {
      holding.weight = newWeights[index];
      holding.amount = totalValueState * newWeights[index];
    });
    return holdings;
  };
  const formatCurrencyInput = num => parseFloat(num).toLocaleString();
  const parseCurrencyString = stringValue => stringValue.replace(/,/g, '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "holdings-editor"
  }, /*#__PURE__*/_react.default.createElement(_Typeahead.default, {
    placeholder: typeHeadPlaceholder,
    currentSelection: holdings,
    updateSelection: handleEntitySelection,
    tabIndex: 1,
    token: token,
    dataspanApiUrl: dataspanApiUrl,
    clientEmail: clientEmail
  }), holdings && holdings.length ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("table", {
    className: "holdings-table"
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: "headings"
  }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    rowSpan: "1",
    className: "order"
  }), /*#__PURE__*/_react.default.createElement("th", {
    rowSpan: "1",
    className: "ticker"
  }, 'ticker'), /*#__PURE__*/_react.default.createElement("th", {
    rowSpan: "1",
    className: "name"
  }, 'name'), /*#__PURE__*/_react.default.createElement("th", {
    rowSpan: "1",
    className: "weight"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "weighting-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "weighting-header-title"
  }, 'weighting'), /*#__PURE__*/_react.default.createElement("div", {
    className: "weight-type"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('option', {
      selected: weightType === 'percent'
    }),
    onClick: () => handleChangeWeightingType('percent')
  }, "%"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('option', {
      selected: weightType === 'currency'
    }),
    onClick: () => handleChangeWeightingType('currency')
  }, "$")))), /*#__PURE__*/_react.default.createElement("th", {
    rowSpan: "1",
    className: "delete-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "delete-all",
    onClick: handleDeleteAllHoldings
  }, "\u2715")))), /*#__PURE__*/_react.default.createElement("tbody", null, holdings.map((holding, rowIndex) => /*#__PURE__*/_react.default.createElement("tr", {
    key: holding.ticker
  }, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "order"
  }), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "ticker"
  }, holding.ticker), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "name"
  }, holding.name), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "weight"
  }, /*#__PURE__*/_react.default.createElement(_reactNumericInput.default, {
    step: weightType === 'currency' ? 1 : 0.1,
    min: 0,
    max: weightType === 'currency' ? null : 100,
    precision: weightType === 'currency' ? 0 : 1,
    value: weightType === 'currency' ? holding.amount : holding.weight * 100,
    onChange: value => handleUpdateSlider(weightType === 'currency' ? value : value / 100, holding),
    style: false,
    snap: true,
    tabIndex: rowIndex + 2,
    format: weightType === 'currency' ? formatCurrencyInput : null,
    parse: parseCurrencyString
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-horizontal"
  }, /*#__PURE__*/_react.default.createElement(_reactRangeslider.default, {
    min: 0,
    max: weightType === 'currency' ? Math.max(totalValueState, 1000000) : 1,
    step: weightType === 'currency' ? 1 : 0.001,
    value: weightType === 'currency' ? holding.amount : holding.weight,
    orientation: "horizontal",
    handleLabel: "",
    tooltip: false,
    onChange: value => handleUpdateSlider(value, holding)
  }))), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "delete-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "delete",
    onClick: () => handleDeleteHolding(holding)
  }, "\u2715")))), /*#__PURE__*/_react.default.createElement("tr", {
    key: "total",
    className: "total"
  }, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "order"
  }), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "ticker"
  }), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "name"
  }), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "sum-weight weight"
  }, /*#__PURE__*/_react.default.createElement(_reactNumericInput.default, {
    step: weightType === 'currency' ? 1 : 0.1,
    min: 0,
    max: weightType === 'currency' ? null : 100,
    precision: weightType === 'currency' ? 0 : 1,
    value: weightType === 'currency' ? totalValueState : sumWeights * 100,
    style: false,
    readOnly: true,
    format: weightType === 'currency' ? formatCurrencyInput : null
  })), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: "1",
    className: "delete-col"
  }))))) : null, /*#__PURE__*/_react.default.createElement(_Uploader.default, {
    checkTickersUrl: checkTickersUrl,
    placeholderLabel: _i18n.default.t('upload-portfolio'),
    updateHoldings: handleUploadHoldings,
    token: token,
    downloadTemplateLabel: 'download-template',
    downloadTemplateTooltipLabel: 'download-template-tooltip',
    uploadFailureLabel: 'upload-failures'
  }));
};
var _default = exports.default = HoldingsEditor;